export default [
  {
    path: '/iap-popup',
    component: () => import('./views/Index'),
    name: 'iap-popup',
    redirect: { name: 'iap-popup-list' },
    children: [
      {
        path: '',
        name: 'iap-popup-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
